import axios from 'axios';
import { FETCH_CITIES, FETCH_CITIES_FAIL } from './types';
import { history } from '../components/app';
import { SLACK_WEBHOOKS, CYOA_NETWORK_IDS  } from '../config';
import { SlackWebhook } from './utils';

/**
 * Fetch network cities via Busabout API
 * @param {String} currency - ISO currency code
 * @param {String} tourID - The ID of the tour (europe / USA)
 */
export function FetchCities(currency, tourID = CYOA_NETWORK_IDS["europe"].id) {

    const FETCH_CITIES_URL = `${process.env.REACT_APP_NETWORK_API}${tourID}/cities?currency=${currency}&api_token=${process.env.REACT_APP_API_TOKEN}`;

    return async dispatch => {
      try{
        const data = await axios.get(FETCH_CITIES_URL);
        dispatch({type:FETCH_CITIES, payload:data});
      }
      catch(err) {
        dispatch({type:FETCH_CITIES_FAIL})
        dispatch(SlackWebhook(SLACK_WEBHOOKS.errors, {'text':'Discovery pages - CITIES API (GET) - '  + FETCH_CITIES_URL + " " + err}));
        console.error(err);
        history.push('/500');
      };
  }
}



// WEBPACK FOOTER //
// ./src/actions/cities.js